import type { InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

const inputClassName =
  'w-full rounded-lg border border-[#858C94] bg-white px-4 py-3.5 text-base disabled:cursor-not-allowed disabled:opacity-50'

const labelClassName = 'mb-2 block text-sm font-semibold text-black'

export interface FormInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> {
  id: string
  label: string
  required?: boolean
  hint?: React.ReactNode
  className?: string
  inputClassName?: string
}

export function FormInput({
  id,
  label,
  required = false,
  hint,
  className,
  inputClassName: inputClassNameProp,
  ...inputProps
}: FormInputProps) {
  return (
    <div className={className}>
      <label htmlFor={id} className={labelClassName}>
        {label}
        {required && <span className="text-primary"> *</span>}
      </label>
      <input
        id={id}
        className={cn(inputClassName, inputClassNameProp)}
        required={required}
        {...inputProps}
      />
      {hint && <p className="text-muted-foreground mt-1 text-xs">{hint}</p>}
    </div>
  )
}
